import React, { useState, useRef } from "react";

const Slider = ({ height, children })=> {

  const ref = useRef();
  const [x         , setX]         = useState(0);
  const [left      , setLeft]      = useState(0);
  const [mouseDown , setMouseDown] = useState(false);

  const onUp = ()=> {
    setMouseDown(false);
    ref.current.style.cursor = 'pointer';
    ref.current.style.userSelect = 'none';
  };

  const onDown = (e)=> {
    setMouseDown(true);
    e.stopPropagation()
    ref.current.style.cursor = 'grabbing';
    setLeft(ref.current.scrollLeft);
    setX(e.clientX);
  };

  const onMove = (e)=> {
    if(!mouseDown) return;
    e.stopPropagation();
    ref.current.scrollLeft = left - (e.clientX - x);
  };

  return  (
    <div ref={ref}
      onMouseMove={onMove}
      onMouseLeave={()=> setMouseDown(false)}
      onMouseDown={onDown}
      onMouseUp={onUp}
      style={{ height, position: 'relative', whiteSpace:"nowrap", overflow: 'hidden' }}
    >
      {children}
    </div>
  )
}

export default Slider;
